import React, { useState, useEffect } from 'react';
import LoginForm from '../Components/LoginForm';
import RegisterForm from '../Components/RegisterForm';
import VerifyEmailForm from '../Components/verifyEmailForm';
import OlvidasteContrasenia from '../Components/olvidasteContrasenia';
import './login.css';
import iconLoggin1 from '../img/iconLoggin1.png'
import iconLoggin2 from '../img/iconLoggin2.png'
import iconLoggin3 from '../img/iconLoggin3.png'
import iconLoggin4 from '../img/iconLoggin4.png'
import iconLoggin5 from '../img/iconLoggin5.png'
import iconLoggin6 from '../img/iconLoggin6.png'
import iconLoggin7 from '../img/iconLoggin7.png'
import iconLoggin8 from '../img/iconLoggin8.png'
import iconLoggin9 from '../img/iconLoggin9.png'
import iconLoggin10 from '../img/iconLoggin10.png'
import iconLoggin11 from '../img/iconLoggin11.png'
import iconLoggin12 from '../img/iconLoggin12.png'
import WhatsAppButton from '../Components/whatsappbutton';


const Login = () => {
  const [activeTab, setActiveTab] = useState('login');

  const handleTabChange = (tab) => {
    console.log('Cambiando pestania a:', tab);
    setActiveTab(tab);
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Estado para ordenar las imágenes manualmente
  const [imageOrder, setImageOrder] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11
  ]);

  const images = [
    iconLoggin1,
    iconLoggin2,
    iconLoggin3,
    iconLoggin4,
    iconLoggin5,
    iconLoggin6,
    iconLoggin7,
    iconLoggin8,
    iconLoggin9,
    iconLoggin10,
    iconLoggin11,
    iconLoggin12,
  ];



  // Actualizar el tamaño de la ventana
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Cambiar el orden manualmente
  const handleImageOrderChange = () => {
    if (windowWidth <= 768) {  // Solo cambiar en pantallas pequeñas
      setImageOrder([3, 1, 5, 2, 11, 0, 6, 8, 4, 7, 10, 9]);
    }
  };

  // Llamada para cambiar el orden (puedes hacerlo de otras formas, dependiendo de cómo quieras cambiarlo)
  useEffect(() => {
    handleImageOrderChange();
  }, [windowWidth]);
  return (


    <div className="main-container-loggin">
      <WhatsAppButton />

      <div className="two-column-container">

        <div className="column">
          <div className="form-lyr-container">
            <div className="change">
              {activeTab === 'login' && <LoginForm handleTabChange={handleTabChange} />}
              {activeTab === 'register' && <RegisterForm handleTabChange={handleTabChange} />}
              {activeTab === 'verifyEmail' && <VerifyEmailForm handleTabChange={handleTabChange} />}
              {activeTab === 'olvidasteContrasenia' && <OlvidasteContrasenia handleTabChange={handleTabChange} />}
            </div>
          </div>
        </div>


        <div className="column2-loggin">
          {imageOrder.map((order, index) => (
            <div className="grid-item-loggin" key={index}>
              <img src={images[order]} alt={`Item ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Login;
